var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderMypage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9C8.175 9 7.46875 8.70625 6.88125 8.11875C6.29375 7.53125 6 6.825 6 6C6 5.175 6.29375 4.46875 6.88125 3.88125C7.46875 3.29375 8.175 3 9 3C9.825 3 10.5312 3.29375 11.1187 3.88125C11.7062 4.46875 12 5.175 12 6C12 6.825 11.7062 7.53125 11.1187 8.11875C10.5312 8.70625 9.825 9 9 9ZM3 15V12.9C3 12.475 3.1095 12.0845 3.3285 11.7285C3.5475 11.3725 3.838 11.1005 4.2 10.9125C4.975 10.525 5.7625 10.2345 6.5625 10.041C7.3625 9.8475 8.175 9.7505 9 9.75C9.825 9.7495 10.6375 9.8465 11.4375 10.041C12.2375 10.2355 13.025 10.526 13.8 10.9125C14.1625 11.1 14.4532 11.372 14.6722 11.7285C14.8912 12.085 15.0005 12.4755 15 12.9V15H3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMypage);
export default __webpack_public_path__ + "static/media/header_mypage.6fbc1894e001b4d4f690f4613d4ee4e6.svg";
export { ForwardRef as ReactComponent };